import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router";
import { Button } from "react-bootstrap";

import KompressorWartungChartContainer from "./KompressorWartungChartContainer";
import KompressorBildContainer from "./KompressorBildContainer";

import AlmigButton from "../grundelemente/AlmigButton";

import "./KompressorWartung.css";

const KompressorWartung = props => (
	<div className="KompressorWartung">
		<div>
			<div>
				<AlmigButton i18n_key={props.location_path.endsWith("image")
					? "Intervals" : "Image"}
				onClick={() => props.showImage(props.location_path)} />
				<Button className="almig-previous-button almig-image-button"
					disabled={props.previous_index === -1}
					onClick={() => props.gotoCompressor(
						props.location_path, props.previous_index)} />
				<Button className="almig-next-button almig-image-button"
					disabled={props.next_index === -1}
					onClick={() => props.gotoCompressor(
						props.location_path, props.next_index)} />
			</div>
		</div>
		<Switch>
			<Route path="/maintenance/compressor/:compressorIndex/image" component={KompressorBildContainer} />
			<Route path="/maintenance/compressor/:compressorIndex" component={KompressorWartungChartContainer} />
			<Redirect exact from="/maintenance/compressor" to={props.default_path} />
		</Switch>
	</div>
);

KompressorWartung.propTypes = {
	location_path: PropTypes.string.isRequired,
	default_path: PropTypes.string.isRequired,
	next_index: PropTypes.number.isRequired,
	previous_index: PropTypes.number.isRequired,
	showImage: PropTypes.func.isRequired,
	gotoCompressor: PropTypes.func.isRequired
};

export default KompressorWartung;
